import React, {useState, useEffect, useContext} from "react"
import {contact_server} from "../trialSteps/contact-server"
import CartContext from "../../contexts/CartContext"
// import config from "../../config"
// const {
//     stripe_key,
// } = config

const OrderCalcPrice = props => {
    const {cart} = useContext(CartContext);

    const {
        databaseData, 
        nextStep,
        onError,
        setDatabaseData,
        stripeKey,
        serverUrl,
    } = props;
    let [contactingServer, setContactingServer] = useState(false)

    useEffect( ()=>{
        checkout()
        setContactingServer(true);
    // eslint-disable-next-line    
    }, [])

    let checkout = ()=>{
        let total = cart.reduce((sum, item)=>sum+item.price, 0)

        let handler = window.StripeCheckout.configure({
          key: stripeKey,
          token: async function(token, args) {
            try {
                let data = {
                    ...databaseData,
                    email: token['email'],
                    card: token['id'],        
                }
                contact_server ({
                    databaseData: data,
                    setDatabaseData,
                    nextStep,
                    onError,
                    url: `${serverUrl}/cart/order_calc_price`,
                });
            } catch ( err ) {
              console.error(err)
              alert(err)
            }
          }
        });
    
      let desc = ""
        handler.open({
            name: 'PatternMaker',
            description: desc + " purchase",
            amount: total * 100
        });
      }

    if (contactingServer)
      return <h2>Validating Order...</h2>
    return <h2> Order validated </h2>
}

export default OrderCalcPrice